/*
    element = any element
    cls = any class name

    function returns (element)'s closest ancestor
    with the class name (cls) (if such an
    ancestor exists)
*/
export function findAncestor(element, cls) {

    let el = element;

    if (el.classList.contains(cls)) {

        return el;

    }

    // eslint-disable-next-line
    while ((el = el.parentElement) && !el.classList.contains(cls));

    return el;

}
